import { initialOf } from '../../lib/utils.js';

interface AvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const AVATAR_PALETTE = [
  { bg: '#E8F5E9', color: '#2E7D32' },
  { bg: '#E3F2FD', color: '#1565C0' },
  { bg: '#FFF3E0', color: '#E65100' },
  { bg: '#F3E5F5', color: '#7B1FA2' },
  { bg: '#E0F7FA', color: '#00838F' },
  { bg: '#FFF8E1', color: '#F9A825' },
  { bg: '#FBE9E7', color: '#D84315' },
  { bg: '#ECEFF1', color: '#455A64' },
  { bg: '#E8EAF6', color: '#3949AB' },
  { bg: '#F1F8E9', color: '#558B2F' },
];

const SIZE_MAP = {
  sm: { width: 32, fontSize: 13 },
  md: { width: 40, fontSize: 16 },
  lg: { width: 48, fontSize: 20 },
  xl: { width: 72, fontSize: 28 },
};

function paletteIndex(name: string): number {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % AVATAR_PALETTE.length;
}

export function Avatar({ name, size = 'md', className = '' }: AvatarProps) {
  const palette = AVATAR_PALETTE[paletteIndex(name)];
  const dims = SIZE_MAP[size];
  const initial = initialOf(name);

  return (
    <div
      className={`ui-avatar ${className}`}
      style={{
        width: dims.width,
        height: dims.width,
        fontSize: dims.fontSize,
        background: palette.bg,
        color: palette.color,
      }}
      title={name}
    >
      {initial}
    </div>
  );
}
